import React from 'react';
import { X } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

export const PHASE5_REGENERATION_COPY = {
  sqis: {
    title: 'Regenerate 14 Points SQIS?',
    message: 'Regeneration may replace previously generated or clinician-edited SQIS content. The current report is preserved unless the replacement is successfully saved. The new SQIS will require review again, and dependent reports will need to be regenerated.',
  },
  why: {
    title: 'Regenerate Why?',
    message: 'Regenerate Why (Patterns & Contributing Themes)? The current Analysis will be preserved unless the new Analysis completes successfully.',
  },
  next: {
    title: 'Regenerate Next Steps?',
    message: 'Regenerate Next Steps? The current Analysis will be preserved unless the new Analysis completes successfully.',
  },
  nexus: {
    title: 'Regenerate Nexus?',
    message: 'Regenerate Nexus? The current Analysis will be preserved unless the new Analysis completes successfully.',
  },
};

const Phase5RegenerationDialog = ({ open, kind, onConfirm, onCancel }) => {
  const copy = PHASE5_REGENERATION_COPY[kind] || PHASE5_REGENERATION_COPY.why;

  return (
    <AlertDialog open={open} onOpenChange={(nextOpen) => { if (!nextOpen) onCancel(); }}>
      <AlertDialogContent data-testid={`phase5-regeneration-dialog-${kind || 'Analysis'}`}>
        <button
          type="button"
          onClick={onCancel}
          className="absolute right-4 top-4 rounded-sm p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          aria-label="Close regeneration confirmation"
          data-testid="phase5-regeneration-close"
        >
          <X className="h-4 w-4" />
        </button>
        <AlertDialogHeader className="pr-8">
          <AlertDialogTitle>{copy.title}</AlertDialogTitle>
          <AlertDialogDescription>{copy.message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid="phase5-regeneration-cancel">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="phase5-regeneration-confirm">
            Confirm
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default Phase5RegenerationDialog;
